import Vue from 'vue';
import Vuex from 'vuex';

import quote from '@/store/modules/quote';
import progress from '@/store/modules/progress';
import validator from '@/store/modules/validator';

Vue.use(Vuex);

const modules = {
	quote,
	progress,
	validator,
};

const state = {
	iframeFlag: null,
};

const getters = {};

const actions = {};

const mutations = {
	TOGGLE_IFRAME(state, flag) {
		state.iframeFlag = flag;
	},
};

export default new Vuex.Store({
	strict: process.env.VUE_APP_STRICT || false,
	modules,
	state,
	getters,
	actions,
	mutations,
});
